import React, {useEffect, useState} from 'react';
import {Button, Modal} from 'reactstrap';
import localeHelpers from "../../helpers/LocaleHelper";
import LocalizedStrings from "react-localization";
import {alert_strings} from "../../translations/alert_translations";
import {common_strings} from "../../translations/common_translations";
import lsHelpers from "../../helpers/LsHelper";
import {isMobile} from "react-device-detect";

let alertStrings = new LocalizedStrings(alert_strings);
let commonStrings = new LocalizedStrings(common_strings);

const VerifiedModal = (props) => {
    const [visible, setVisible] = useState(props.showVerifiedModal === true);

    useEffect(() => {
        lsHelpers.increaseWelcomeShown()
    }, [])

    const localize = () => {
        const loc = localeHelpers.currentLocale();
        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
    };

    localize();

    function toggleVerifiedModal() {
        setVisible(!visible)
        props.toggleVerifiedModal()
        if (props.appLink && isMobile) {
            window.open(props.appLink, '_blank');
        }
    }

    return (
        <Modal
            className="modal-dialog-centered modal-success"
            contentClassName="bg-gradient-success"
            isOpen={visible}
            toggle={() => toggleVerifiedModal()}
        >
            <div className="modal-header">
                <h6 className="modal-title" id="modal-title-notification">
                    {/*Your attention is required*/}
                </h6>
                <button
                    aria-label="Close"
                    className="close"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => toggleVerifiedModal()}
                >
                    <span aria-hidden={true}>×</span>
                </button>
            </div>
            <div className="modal-body">
                <div className="py-3 text-center">
                    <img
                        alt="..."
                        width={100}
                        src={require("assets/img/brand/open-white-logo.png")}/>
                    <h4 className="heading mt-4">{alertStrings.success}</h4>
                    <p>
                        {alertStrings.account_verified}
                    </p>

                </div>
            </div>
            <div className="modal-footer">
                <Button
                    className="text-white ml-auto"
                    color="warning"
                    data-dismiss="modal"
                    type="button"
                    onClick={(e) => toggleVerifiedModal()}
                >
                    {commonStrings.close}
                </Button>
            </div>
        </Modal>
    );
};

export default VerifiedModal;